import { BankRoutes } from '../routes';

import IntegrationLogs from '../hoc/integration-logs/integration-logs';
import IntegrationLogsList from '../hoc/integration-logs/list';
import IntegrationLog from '../hoc/integration-logs/integration-log';

const IntegrationLogsRoutes = {
  path: BankRoutes.INTEGRATIONS_LOGS,
  element: <IntegrationLogs />,
  children: [
    {
      path: BankRoutes.INTEGRATIONS_LOGS_LIST,
      element: <IntegrationLogsList />,
      children: [
        {
          path: BankRoutes.INTEGRATIONS_LOGS_ITEM,
          element: <IntegrationLog />,
        },
      ],
    },
  ],
};

export default IntegrationLogsRoutes;
